/* eslint-disable no-unused-vars */
import mixpanelBlackList from "@utils/constants/mixpanelBlackList";
import { AnalyticMetaData } from "@customTypes/services/analyticEvents";
import analyticEvents from "@utils/constants/analyticEvents";

const mixpanel = window.mixpanel;

const track = (eventName: string, metaData: AnalyticMetaData) => {
  if (mixpanelBlackList.includes(eventName)) return;
  const events = Object.values(analyticEvents);
  if (events.includes(eventName) && !!mixpanel) {
    mixpanel.track(eventName, metaData);
  }
};

export default { track };
